import { toArray } from "lodash-es";
import { useSelector } from "react-redux";

export const useProvidersFetch = () => {
  return useSelector(({ games }) => games.providersFetch);
};

export const useCurrentProviderId = () => {
  return useSelector(({ games }) => games.currentProviderId);
};

export const useProviders = () => {
  return useSelector(({ games }) => toArray(games.providers));
};

export const useCurrentProvider = () => {
  return useSelector(({ games }) => games.currentProvider);
};

export const useIsJackpotsShown = () => {
  return useSelector(({ games }) => games.isJackpotsShown);
};

export const useComputedProviders = () => {
  return useSelector(({ games }) => toArray(games.computedProviders));
};
